import { Dropdown } from "semantic-ui-react";

export default function CustomFieldDropdown({
  customFieldConfigs = [],
  onUpdateCustomFieldConfigs,
}) {
  const dropdownOptions = customFieldConfigs.map(cf => ({
    id: cf.id,
    value: cf.id,
    text: cf.label,
    disabled: cf.selected || cf.required,
  }));

  const handleCustomFieldConfigSelect = (event, data) => {
    const customFieldConfigsCopy = customFieldConfigs.map(cfc => ({
      ...cfc,
      selected: cfc.selected || cfc.id == data.value,
    }));
    onUpdateCustomFieldConfigs(customFieldConfigsCopy);
  };

  return (
    <Dropdown
      className="button icon tiny cf-dropdown"
      basic
      floating
      labeled
      search
      icon="plus"
      text="Add Custom Fields"
      name="customFieldConfigs"
      options={dropdownOptions}
      value={null}
      onChange={handleCustomFieldConfigSelect}
      selectOnBlur={false}
    />
  );
}
